import { CloseButton, Dialog, DialogPanel } from "@headlessui/react";

import { Dispatch, JSX, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import CommentCard from "@/components/cards/CommentCard/CommentCard.tsx";
import { IconX } from "@/components/icons";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isFull: boolean;
  text: string;
  rating: number;
  time: string;
  user: string;
}

const CommentDetailModal = ({ isOpen, setIsOpen, isFull, text, rating, time, user }: ModalProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} as="div" className="relative z-10 focus:outline-none" onClose={() => setIsOpen(false)}>
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center bg-black bg-opacity-60 p-4">
          <DialogPanel
            transition
            className="data-[closed]:transform-[scale(95%)] w-full max-w-md rounded-xl bg-black-1 text-white shadow-[0px_0px_2.875rem_#ff570830] duration-300 ease-out data-[closed]:opacity-0"
          >
            <CommentCard isFull={isFull} text={text} rating={rating} time={time} user={user} />
          </DialogPanel>
        </div>
        <CloseButton
          as={"button"}
          aria-label={t("Actions.close")}
          className={"absolute right-14 top-14 max-lg:right-4 max-lg:top-4"}
        >
          <IconX className={"size-9 stroke-white max-lg:size-8"} />
        </CloseButton>
      </div>
    </Dialog>
  );
};

export default CommentDetailModal;
